<template>
  <div class="scheduleListBody">
    <h3>
      {{dispDate(this.talkShow.startAt)}}
    </h3>
    <div class="scheduleInfo">
      <h4>{{dispStartTime}}~{{dispEndTime}}</h4>
      <div class="scheduleInfoBody">
        <div class="scheduleImg">
          <a href="javascript:void(0);" style="cursor: pointer;" :class="{clickDisable: !hasLink()}" @click="openLink()"><img alt="" :src="getThumbnail(talkShow.thumbnailUrl)" /></a>
          <p v-if="isOnAir()" class="status">ON AIR</p>
          <p v-if="mode=='archives' && !hasArchive()" class="status">準備中</p>
          <p v-if="mode=='archives' && hasArchive()" class="status2">配信終了</p>
        </div><!-- /scheduleImg-->
        <p class="cName">{{talkShow.clients}}</p>
        <h5>{{talkShow.title}}</h5>
        <div class="scheduleAbout">
          <p class="guest">ゲスト：{{talkShow.speakers}}</p>
          <p class="txt" style="white-space: pre-wrap;">{{talkShow.description}}</p>
        </div><!-- /scheduleImg-->
        <div class="scheduleButton" v-if="mode=='schedule' && isOnAir()">
          <a href="javascript:void(0);" class="StandardBtn onAir" @click="openLiveLink()">ON AIR中&nbsp;ライブ配信を見る</a>
        </div>
        <div class="scheduleButton" v-if="mode=='schedule' && hasLiveLink()">
          <a href="javascript:void(0);" class="StandardBtn" @click="openLink()">配信画面はこちら</a>
        </div>
        <div class="scheduleButton" v-if="mode=='archives' && hasReport()">
          <a href="javascript:void(0);" class="StandardBtn" @click="openReportLink()">トークショーレポートはこちら</a>
        </div>
        <div class="scheduleButton" v-if="mode=='archives' && hasArchive()">
          <a href="javascript:void(0);" class="StandardBtn" @click="openArchiveLink()">動画のアーカイブはこちら</a>
        </div>
      </div><!-- /scheduleInfoBody-->
    </div><!-- /scheduleInfo-->
  </div><!-- /scheduleListBody-->
</template>

<script>
import moment from 'moment-timezone'

export default {
  components: {
  },
  data () {
    return {
      holidayList: ['2021-11-03', '2021-11-23']
    }
  },
  props: [
    'talkShow',
    'mode',
    'nowDateTime'
  ],
  created () {
  },
  methods: {
    // トークショーが終了している場合falseを返す
    isOnAir () {
      if (this.mode === 'schedule') {
        if (this.nowDateTime < moment(this.talkShow.startAt).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
          return false
        }
        if (this.nowDateTime > moment(this.talkShow.endAt).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')) {
          return false
        }
        return true
      }
      return false
    },
    // トークショー前でリンクが存在する場合
    hasLiveLink () {
      if (this.mode === 'schedule') {
        if (this.nowDateTime >= moment(this.talkShow.startAt).tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss') || !this.talkShow.liveLink) {
          return false
        }
        return true
      }
      return false
    },
    hasArchive () {
      if (this.mode === 'archives') {
        if (!this.talkShow.archiveLink) {
          return false
        }
        return true
      }
      return false
    },
    hasReport () {
      if (this.mode === 'archives') {
        if (this.talkShow.reportLink) {
          return true
        }
      }
      return false
    },
    hasLink () {
      if (this.isOnAir() || this.hasLiveLink()) {
        return true
      }
      if (this.hasArchive()) {
        return true
      }
      if (this.hasReport()) {
        return true
      }
      return false
    },
    openLink () {
      if (this.isOnAir() || this.hasLiveLink()) {
        if (!this.talkShow.liveLink) {
          window.open('https://www.instagram.com/tokyocameraclub/', '_blank')
        } else {
          window.open(this.talkShow.liveLink, '_blank')
        }
      }
      if (this.hasReport()) {
        location.href = this.talkShow.reportLink
      } else if (this.hasArchive()) {
        window.open(this.talkShow.archiveLink, '_blank')
      }
    },
    openLiveLink () {
      if (this.isOnAir()) {
        if (!this.talkShow.liveLink) {
          window.open('https://www.instagram.com/tokyocameraclub/', '_blank')
        } else {
          window.open(this.talkShow.liveLink, '_blank')
        }
      }
    },
    openArchiveLink () {
      if (this.talkShow.archiveLink) {
        window.open(this.talkShow.archiveLink, '_blank')
      }
    },
    openReportLink () {
      if (this.talkShow.reportLink) {
        location.href = this.talkShow.reportLink
      }
    },
    getThumbnail(thumbnailUrl) {
      if (thumbnailUrl) {
        return thumbnailUrl
      }
      return '/img/comingSoon.jpg'
    }
  },
  computed: {
    dispStartTime: {
      get () {
        return moment(this.talkShow.startAt).tz('Asia/Tokyo').format('HH:mm')
      }
    },
    dispEndTime: {
      get () {
        return moment(this.talkShow.endAt).tz('Asia/Tokyo').format('HH:mm')
      }
    },
    dispDate: function () {
      return function (date) {
        if (date) {
          let dispDate = moment(date).tz('Asia/Tokyo').format('M月D日（ddd）')
          if (this.holidayList.indexOf(date.substring(0, 10)) >= 0) {
            dispDate = dispDate.slice(0, -1) + '・祝）'
          }
          return dispDate
        }
      }
    }
  }

}
</script>

<style>
.clickDisable {
  pointer-events: none;
}

</style>
